import { bindActionCreators } from "redux";
import { ADD_COMMENT, DELETE_COMMENT, COUNT_COMMENTS } from "./constants";
import * as commentActions from "./actions";
import hash from "object-hash";

const createCommentListParams = props => {
  const { resourceType, resourceId } = props;
  const id = hash({ resourceType, resourceId });
  return { id, resourceType, resourceId };
};

const createCommentCountParams = props => {
  const { resourceType, resourceId } = props;
  const actionType = `${COUNT_COMMENTS}`;
  const id = hash({ resourceType, resourceId, actionType });
  return { id, resourceType, resourceId };
};

const handleCommentAction = actions => action => {
  const { listComments, countComments } = actions;
  const {
    payload: { params }
  } = action;
  listComments(createCommentListParams(params));
  countComments(createCommentCountParams(params));
};

const actionHandlers = {
  [ADD_COMMENT.SUCCESS]: handleCommentAction,
  [DELETE_COMMENT.SUCCESS]: handleCommentAction
};

const handleAction = actions => action => {
  if (action.type in actionHandlers) {
    actionHandlers[action.type](actions)(action);
  }
};

export const commentFlowMiddleware = store => next => action => {
  const { dispatch } = store;
  const actions = bindActionCreators(commentActions, dispatch);
  handleAction(actions)(action);
  return next(action);
};



// WEBPACK FOOTER //
// ./src/app/comments/middleware.js